import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getInfractionsPaginated } from "../services/infractions.service";
import type {
	InfractionListItemApiResponse,
	InfractionPaginatedRequest,
} from "../types/infraction-api.types";
import { infractionQueryKeys } from "./infraction-query-keys";

export type InfractionsPaginatedQueryData = {
	items: InfractionListItemApiResponse[];
	totalCount: number;
	pageSize: number;
	currentPage: number;
	totalPages: number;
};

export function useInfractionsPaginated(params: InfractionPaginatedRequest) {
	return useQuery<InfractionsPaginatedQueryData>({
		queryKey: infractionQueryKeys.paginated(params),
		queryFn: async () => {
			const response = await getInfractionsPaginated(params);
			return {
				items: response.items ?? [],
				totalCount: response.totalCount,
				pageSize: response.pageSize,
				currentPage: response.currentPage,
				totalPages: response.totalPages,
			};
		},
		enabled: params.pageNumber >= 1 && params.pageSize >= 1,
		placeholderData: keepPreviousData,
	});
}
